export enum Role {
    Administrator = 1,
    Basic,
    "Regional Leader",
    "Field Engineer",
    "PSL NOC Team",
    "Campaign Manager",
    "Technical Expert",
    Installer
}